import Call from '../Call';
import {objToQs} from '../Utils';

const DynamicCutoff = {
    get(filters) {
        return Call(`dynamicCutoff?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`dynamicCutoff/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`dynamicCutoff/affid`);
    },

    getSubids(filters) {
        return Call(`dynamicCutoff/subid?${objToQs(filters)}`);
    },
    getSubidsAll(filters) {
        return Call(`dynamicCutoff/subid/all?${objToQs(filters)}`);
    },
    updateFactor(affid, subid, country, cutoff, type) {
        return Call(`dynamicCutoff/factor`, 'PUT', { affid, subid, country, cutoff, type })
    }
};

export default DynamicCutoff;


// WEBPACK FOOTER //
// ./src/services/API/components/DynamicCutoff.js